/* ===================
    FORMS
====================== */
function validateFormContact() {
    return true;
}

function validateFormPhone() {
    return true;
}

/* ===================
	PUSHED NAV
====================== */
var showRight = document.getElementById( 'showRight' ),
    menuRight = document.getElementById( 'main-menu' ),
    body = document.body;

showRight.onclick = function() {
    classie.toggle( this, 'active' );
    classie.toggle( menuRight, 'main-menu-open' );
    disableOther( 'showRight' );
};

function disableOther( button ) {
    if( button !== 'showRight' ) {
        classie.toggle( showRight, 'disabled' );
    }
}

/* ===================
	SCROLL NAV HEAD
====================== */
$(function() {
    $('a.page-scroll').bind('click', function(event) {
        var $anchor = $(this);
        $('html, body').stop().animate({
            scrollTop: $($anchor.attr('href')).offset().top
        }, 1200, 'easeInOutExpo');
        event.preventDefault();
    });
});

/* ===================
	SCROLL TO TOP
====================== */
if ( ($(window).height() + 100) < $(document).height() ) {
    $('#top-link-block').removeClass('hidden').affix({
        offset: {top:100}
    });
}